import { Icon } from '@iconify/react'
import clsx from 'clsx'

import s from './SubMenuBtn.module.css'

type Props = {
  children: React.ReactNode
  showArrowIcon?: React.ReactNode
  loading?: boolean
  onClick?: () => void
}

const SubMenuBtn = ({
  children,
  onClick,
  loading,
  showArrowIcon = true,
}: Props) => {
  return (
    <div
      role="none"
      className={clsx(s.btn, {
        [s.disabled]: loading,
      })}
      onClick={onClick}
    >
      {children}
      {showArrowIcon && <Icon icon="lucide:arrow-right" />}
    </div>
  )
}

export default SubMenuBtn
